import { render, staticRenderFns } from "./ExpensesTypeAdd.vue?vue&type=template&id=596db565&"
import script from "./ExpensesTypeAdd.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports